// extracted by mini-css-extract-plugin
export default {"shop_category_container":"ShopByCategory_shop_category_container__Suk0q"};